import { resolveWebGameUrl, type WebGameUrlResolution } from './WebGameStage';

export const ROOM_LINK_LIST = 'room-links:list';
export const ROOM_LINK_SUBMIT = 'room-links:submit';
export const ROOM_LINK_DISMISS = 'room-links:dismiss';
/** Invalidation only. URLs are returned privately to the host or their submitter. */
export const ROOM_LINK_CHANGED = 'room-links:changed';
export const ROOM_LINK_MAX_LENGTH = 2048;

export interface RoomLinkSuggestion {
  id: string;
  url: string;
  hostname: string;
  submittedBySessionId: string;
  submittedByAlias: string;
  submittedAt: number;
}

export interface RoomLinkAck {
  ok: boolean;
  error?: string;
  suggestions?: RoomLinkSuggestion[];
}

export function resolveRoomLinkUrl(input: string, pageOrigin?: string): WebGameUrlResolution {
  if (!input.trim()) return { ok: false, error: 'Enter a website or web-game URL.' };
  if (input.length > ROOM_LINK_MAX_LENGTH) return { ok: false, error: 'This link is too long.' };
  const resolved = resolveWebGameUrl(input, { pageOrigin });
  if (!resolved.ok) return resolved;
  const parsed = new URL(resolved.url);
  if (parsed.username || parsed.password) return { ok: false, error: 'Use a link without a username or password.' };
  return resolved;
}
